export enum OCRResult {
  Success = 1,
  Error = 2,
  Unknown = 3,
}
